module.exports = __webpack_public_path__ + "static/media/Gilmer-Heavy.145416cc.otf";